export default __webpack_public_path__ + "static/media/MachineRunning.30f0ddf1.jpg";